import CommonApp from '../app.js';

var PhoneDetailsFactory = function() {
    var countryList = {
        'US': {
            'countryName': 'United States',
            'countryPhoneCode': '+1',
            'imageUrl': '/etc/clientlibs/mecommerce/core/main/css/src/assets/images/content/countries/us.svg',
            'placeholder': '(123) 456-7890',
            'mask': '(999) 999-9999'
        },
        'CA': {
            'countryName': 'Canada',
            'countryPhoneCode': '+1',
            'imageUrl': '/etc/clientlibs/mecommerce/core/main/css/src/assets/images/content/countries/ca.svg',
            'placeholder': '123-456-7890',
            'mask': '999-999-9999'
        },
        'AU': {
            'countryName': 'Australia',
            'countryPhoneCode': '+61',
            'imageUrl': '/etc/clientlibs/mecommerce/core/main/css/src/assets/images/content/countries/au.svg',
            'placeholder': '12 3456 7890',
            'mask': '99 9999 999?9'
        },
        'NZ': {
            'countryName': 'New Zealand',
            'countryPhoneCode': '+64',
            'imageUrl': '/etc/clientlibs/mecommerce/core/main/css/src/assets/images/content/countries/nz.svg',
            'placeholder': '12 3456 7890',
            'mask': '99 9999 999?9'
        },
        'GB': {
            'countryName': 'United Kingdom',
            'countryPhoneCode': '+44',
            'imageUrl': '/etc/clientlibs/mecommerce/core/main/css/src/assets/images/content/countries/gb.svg',
            'placeholder': '01234567890',
            'mask': '99999999999'
        },
        'AT': {
            'countryName': 'Austria',
            'countryPhoneCode': '+43',
            'imageUrl': '/etc/clientlibs/mecommerce/core/main/css/src/assets/images/content/countries/at.svg',
            'placeholder': '1234-567890',
            'mask': '9999-999999'
        },
        'BE': {
            'countryName': 'Belgium',
            'countryPhoneCode': '+32',
            'imageUrl': '/etc/clientlibs/mecommerce/core/main/css/src/assets/images/content/countries/be.svg',
            'placeholder': '1234 567 890',
            'mask': '9999 999 999'
        },
        'CZ': {
            'countryName': 'Czech Republic',
            'countryPhoneCode': '+420',
            'imageUrl': '/etc/clientlibs/mecommerce/core/main/css/src/assets/images/content/countries/cz.svg',
            'placeholder': '123-456-789',
            'mask': '999-999-999'
        },
        'DE': {
            'countryName': 'Germany',
            'countryPhoneCode': '+49',
            'imageUrl': '/etc/clientlibs/mecommerce/core/main/css/src/assets/images/content/countries/de.svg',
            'placeholder': '01234567890',
            'mask': '99999999999'
        },
        'DK': {
            'countryName': 'Denmark',
            'countryPhoneCode': '+45',
            'imageUrl': '/etc/clientlibs/mecommerce/core/main/css/src/assets/images/content/countries/den.svg',
            'placeholder': '12 34 56 78',
            'mask': '99 99 99 99'
        },
        'ES': {
            'countryName': 'Spain',
            'countryPhoneCode': '+34',
            'imageUrl': '/etc/clientlibs/mecommerce/core/main/css/src/assets/images/content/countries/es.svg',
            'placeholder': '123 456789',
            'mask': '999 999999'
        },
        'FI': {
            'countryName': 'Finland',
            'countryPhoneCode': '+358',
            'imageUrl': '/etc/clientlibs/mecommerce/core/main/css/src/assets/images/content/countries/fi.svg',
            'placeholder': '0412 345 67 89',
            'mask': '999?9 999 99 99'
        },
        'FR': {
            'countryName': 'France',
            'countryPhoneCode': '+33',
            'imageUrl': '/etc/clientlibs/mecommerce/core/main/css/src/assets/images/content/countries/fr.svg',
            'placeholder': '01234567890',
            'mask': '99999999999'
        },
        'HU': {
            'countryName': 'Hungary',
            'countryPhoneCode': '+36',
            'imageUrl': '/etc/clientlibs/mecommerce/core/main/css/src/assets/images/content/countries/hu.svg',
            'placeholder': '(12) 345-6789',
            'mask': '(99) 999-9999'
        },
        'IE': {
            'countryName': 'Ireland',
            'countryPhoneCode': '+353',
            'imageUrl': '/etc/clientlibs/mecommerce/core/main/css/src/assets/images/content/countries/ire.svg',
            'placeholder': '081 234 5678',
            'mask': '999 999 9999'
        },
        'IL': {
            'countryName': 'Israel',
            'countryPhoneCode': '+44',
            'imageUrl': '/etc/clientlibs/mecommerce/core/main/css/src/assets/images/content/countries/il.svg',
            'placeholder': '123 456 7890',
            'mask': '123 456 7890'
        },
        'IS': {
            'countryName': 'Iceland',
            'countryPhoneCode': '+354',
            'imageUrl': '/etc/clientlibs/mecommerce/core/main/css/src/assets/images/content/countries/is.svg',
            'placeholder': '123 4567',
            'mask': '999 9999'
        },
        'IT': {
            'countryName': 'Italy',
            'countryPhoneCode': '+39',
            'imageUrl': '/etc/clientlibs/mecommerce/core/main/css/src/assets/images/content/countries/it.svg',
            'placeholder': '1234 567 890',
            'mask': '9999 999 999'
        },
        'LU': {
            'countryName': 'Luxembourg',
            'countryPhoneCode': '+352',
            'imageUrl': '/etc/clientlibs/mecommerce/core/main/css/src/assets/images/content/countries/lu.svg',
            'placeholder': '123 456 789',
            'mask': '999 999 999'
        },
        'NL': {
            'countryName': 'The Netherlands',
            'countryPhoneCode': '+31',
            'imageUrl': '/etc/clientlibs/mecommerce/core/main/css/src/assets/images/content/countries/nl.svg',
            'placeholder': '123456789',
            'mask': '999999999'
        },
        'NO': {
            'countryName': 'Norway',
            'countryPhoneCode': '+47',
            'imageUrl': '/etc/clientlibs/mecommerce/core/main/css/src/assets/images/content/countries/no.svg',
            'placeholder': '01234567890',
            'mask': '99999999999'
        },
        'PT': {
            'countryName': 'Portugal',
            'countryPhoneCode': '+351',
            'imageUrl': '/etc/clientlibs/mecommerce/core/main/css/src/assets/images/content/countries/pt.svg',
            'placeholder': '12 345 6789',
            'mask': '99 999 9999'
        },
        'RO': {
            'countryName': 'Romania',
            'countryPhoneCode': '+40',
            'imageUrl': '/etc/clientlibs/mecommerce/core/main/css/src/assets/images/content/countries/ro.svg',
            'placeholder': '12 345 6789',
            'mask': '99 999 9999'
        },
        'RU': {
            'countryName': 'Russia',
            'countryPhoneCode': '+7',
            'imageUrl': '/etc/clientlibs/mecommerce/core/main/css/src/assets/images/content/countries/ru.svg',
            'placeholder': '123 45 67',
            'mask': '999 99 99'
        },
        'SE': {
            'countryName': 'Sweden',
            'countryPhoneCode': '+46',
            'imageUrl': '/etc/clientlibs/mecommerce/core/main/css/src/assets/images/content/countries/se.svg',
            'placeholder': '012 345 67 89',
            'mask': '?999 ?999 99 99'
        },
        'SK': {
            'countryName': 'Slovakia',
            'countryPhoneCode': '+421',
            'imageUrl': '/etc/clientlibs/mecommerce/core/main/css/src/assets/images/content/countries/sk.svg',
            'placeholder': '123-456789',
            'mask': '999-999999'
        },
        'ZA': {
            'countryName': 'South Africa',
            'countryPhoneCode': '+27',
            'imageUrl': '/etc/clientlibs/mecommerce/core/main/css/src/assets/images/content/countries/za.svg',
            'placeholder': '123-456-7890',
            'mask': '999-999-9999'
        },
        'SG': {
            'countryName': 'Singapore',
            'countryPhoneCode': '+65',
            'imageUrl': '/etc/clientlibs/mecommerce/core/main/css/src/assets/images/content/countries/sg.svg',
            'placeholder': '1234-5678',
            'mask': '9999-9999'
        },
        'PH': {
            'countryName': 'Philippines',
            'countryPhoneCode': '+63',
            'imageUrl': '/etc/clientlibs/mecommerce/core/main/css/src/assets/images/content/countries/ph.svg',
            'placeholder': '1234-5678901',
            'mask': '9999-9999999'
        },
        'MY': {
            'countryName': 'Malaysia',
            'countryPhoneCode': '+60',
            'imageUrl': '/etc/clientlibs/mecommerce/core/main/css/src/assets/images/content/countries/my.svg',
            'placeholder': '012-345 6789',
            'mask': '999-999?99999'
        },
        'HK': {
            'countryName': 'Hong Kong',
            'countryPhoneCode': '+852',
            'imageUrl': '/etc/clientlibs/mecommerce/core/main/css/src/assets/images/content/countries/hk.svg',
            'placeholder': '1234-5678',
            'mask': '9999-9999'
        },
        'MO': {
            'countryName': 'Macau',
            'countryPhoneCode': '+853',
            'imageUrl': '/etc/clientlibs/mecommerce/core/main/css/src/assets/images/content/countries/ma.svg',
            'placeholder': '1234-5678',
            'mask': '9999-9999'
        },
        'TH': {
            'countryName': 'Thailand',
            'countryPhoneCode': '+66',
            'imageUrl': '/etc/clientlibs/mecommerce/core/main/css/src/assets/images/content/countries/th.svg',
            'placeholder': '01 234 5678',
            'mask': '99 999 9999'
        },
        'ID': {
            'countryName': 'Indonesia',
            'countryPhoneCode': '+62',
            'imageUrl': '/etc/clientlibs/mecommerce/core/main/css/src/assets/images/content/countries/id.svg',
            'placeholder': '012-345-678',
            'mask': '?9999?9999?9999'
        },
        'BN': {
            'countryName': 'Brunei',
            'countryPhoneCode': '+673',
            'imageUrl': '/etc/clientlibs/mecommerce/core/main/css/src/assets/images/content/countries/brunei.svg',
            'placeholder': '712-3456',
            'mask': '999-9999'
        },
        'VN': {
            'countryName': 'Vietnam',
            'countryPhoneCode': '+84',
            'imageUrl': '/etc/clientlibs/mecommerce/core/main/css/src/assets/images/content/countries/vn.svg',
            'placeholder': '0123 4567 890',
            'mask': '9999 9999 999'
        }
    };

    var getCountryList = function() {
        return countryList;
    };

    return {
        'getCountryList': getCountryList
    };
};

CommonApp.module.factory('phoneDetailsFactory', PhoneDetailsFactory);



//////////////////
// WEBPACK FOOTER
// /Users/geoffsagers/dev/webcomponents/js/packages/common-account/src/angular/factory/phone-details-countries.js
// module id = 279
// module chunks = 0